import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import 'tw-elements';
import 'flowbite';
// Rainbow KIT
import "@rainbow-me/rainbowkit/styles.css";
import {
  getDefaultWallets,
  RainbowKitProvider,
  darkTheme,
  lightTheme,
} from "@rainbow-me/rainbowkit";
import { chain, configureChains, createClient, WagmiConfig } from "wagmi";
// import { alchemyProvider } from "wagmi/providers/alchemy";
import { publicProvider } from "wagmi/providers/public";
import { HashRouter,BrowserRouter } from "react-router-dom";

const { chains, provider } = configureChains(
  [chain.polygon,chain.polygonMumbai],
  [
    // alchemyProvider({ alchemyId: "yJKPlv6vVpN7wcG0-eeLfIw9jRS0CJ1p" }),
    publicProvider(),
  ]
);

const { connectors } = getDefaultWallets({
  appName: "Creative Wealth",
  chains,
});

const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <WagmiConfig client={wagmiClient}>
    <RainbowKitProvider
      chains={chains}
      coolMode
      theme={lightTheme({
        accentColor: "#2F47FA",
        accentColorForeground: "white",
        // borderRadius: "large",
        // overlayBlur: "small",
        // borderRadius: "small",
      })}
    >
      <HashRouter>
        <App />
      </HashRouter>
    </RainbowKitProvider>
  </WagmiConfig>
);

reportWebVitals();
